import axios from "axios";
// import {getToken} from "../Utils/Common";
import {refreshPage} from "../Utils/Common";
import toast from "react-hot-toast";

// var userKey = getAPIKey();

// const getAPIKey = () => {
//     const userStr = localStorage.getItem("api-key");
//     if (userStr) return userStr;
//     else return null;
// };

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      const requestUrl = error.config?.url;

      const ignored401Endpoints = ["/authenticate/index", "login/index"];
      const shouldLogout = !ignored401Endpoints.some(path => requestUrl.includes(path));
  
      if (shouldLogout) {
        localStorage.clear();
        toast.error("Unauthorized. Logging you out...", { autoClose: 5000 });
        setTimeout(() => {
          window.location.href = "/";
          refreshPage();
        }, 1000);
      }
    }

    // Propagate the error to the calling code
    return Promise.reject(error);
  }
);

var config = {
    "api-key": "fJcibSRzJQv2NmJmzgnxsgMu56ucqpLBlJIA9FfaQMI9XxQ0Kxm2sEoMQfwisy0b",
    // "Access-Control-Request-Headers":"*",
};
var putconfig = {
    "api-key": "fJcibSRzJQv2NmJmzgnxsgMu56ucqpLBlJIA9FfaQMI9XxQ0Kxm2sEoMQfwisy0b",
    "Content-Type": "application/x-www-form-urlencoded",
};
// var putconfig = {
//     "api-key": "fJcibSRzJQv2NmJmzgnxsgMu56ucqpLBlJIA9FfaQMI9XxQ0Kxm2sEoMQfwisy0b",
//     "Access-Control-Allow-Origin": "PUT",
//     "Content-Type": "application/json",
//     Accept: "application/json",
// };

var fileconfig = {
    "api-key": "fJcibSRzJQv2NmJmzgnxsgMu56ucqpLBlJIA9FfaQMI9XxQ0Kxm2sEoMQfwisy0b",
};

// API Axios Get Call
export const getAPICall = (url, data) => {
    return axios.get(url, { headers: config }, data);
};
// export const getAPICall = (url, data) => {
//     return axios.get(url, {headers: config});
// };
export const getWithParamsAPICall = (url, data) => {
    return axios.get(url, { headers: config, params: data });
};
// API Axios Post Call.
export const postAPICall = (url, data) => {
    return axios.post(url, data, { headers: config });
};

// API Axios Post Call.
export const postAPICall2 = (url, data, config) => {
    return axios.post(url, data, { headers: fileconfig });
};

// API Axios Put Call.
export const putAPICall = (url, data) => {
    return axios.put(url, data, { headers: putconfig });
};
// API Axios Delete Call.
export const deleteAPICall = (url) => {
    return axios.delete(url, { headers: config });
};
